// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3IJBs","info":"Note_info__3I-S4","note":"Note_note__3Beeh","actions":"Note_actions__1uc_o"};